module.exports = __webpack_public_path__ + "img/view-more.5819e8e3.jpg";